// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_dp-b";
export var colorBlue = "_dp-8";
export var colorDot = "_dp-0";
export var colorDotLarge = "_dp-2";
export var colorDotSmall = "_dp-1";
export var colorGreen = "_dp-7";
export var colorGrey = "_dp-3";
export var colorOrange = "_dp-5";
export var colorPink = "_dp-a";
export var colorPurple = "_dp-9";
export var colorRed = "_dp-4";
export var colorYellow = "_dp-6";